import React, { useState } from 'react';
import {
    Box,
    Button,
    Card,
    CardActionArea,
    FormControl,
    Stack,
    Typography,
} from '@mui/material';
import { useTranslation } from '../../../contexts/TranslationContext';
import CmsSelectPageDialog from '../../dialog/CmsSelectPageDialog';
import { FormFieldProps } from './index';
import { PageListItem } from '../../../api/types/cms';

export default function PageSelectorFormField({
    label,
    value,
    disabled,
    cssClassName,
    onChange,
    locale,
}: FormFieldProps) {
    const { translate } = useTranslation();

    const [open, setOpen] = useState(false);

    const navigateToPage = () => {
        window.open(`/cms/pages/${value?.id}/edit/${value?.locale}`, '_blank');
    };

    const onModalValueChange = (page: PageListItem) => {
        onChange({
            id: page.id,
            locale: page.locale,
            slug: page.slug,
            title: page.title,
            bind_value: page.bind_value,
        });
    };

    return (
        <FormControl fullWidth className={cssClassName}>
            <Stack spacing={0.5}>
                <Typography variant="body1" color="text.secondary">
                    {translate(label)}
                </Typography>
                <Stack direction="row" alignItems="center" spacing={2}>
                    {value && value.slug ? (
                        <CardActionArea
                            onClick={navigateToPage}
                            sx={{ borderRadius: 1, width: 'fit-content' }}>
                            <Card sx={{ p: 1, minWidth: 200 }}>
                                <Typography variant="subtitle1">
                                    {value.title}
                                </Typography>
                                <Typography variant="subtitle2">
                                    {value.bind_value
                                        ? value?.slug.replace(
                                              /\{.*\}/g,
                                              value.bind_value ?? '',
                                          )
                                        : value?.slug}
                                </Typography>
                            </Card>
                        </CardActionArea>
                    ) : (
                        <Typography variant="overline">
                            {translate('form.general.not_selected')}
                        </Typography>
                    )}
                    <Box
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-end',
                        }}>
                        <Button
                            color="primary"
                            disabled={disabled}
                            onClick={() => setOpen(true)}>
                            {translate('pages.cms.pages.selector.title')}
                        </Button>
                    </Box>
                </Stack>
                <CmsSelectPageDialog
                    open={open}
                    value={value}
                    locale={locale ?? value?.locale ?? 'de-DE'}
                    onChange={onModalValueChange}
                    onClose={() => setOpen(false)}
                />
            </Stack>
        </FormControl>
    );
}
